module.exports = __webpack_public_path__ + "img/sign-hj-wan.43dbe41e.png";